import React, { useState } from "react";
import { useConnect } from "wagmi";
import { WalletAppsSheet } from "./WalletAppsSheet";

export const hasInjectedWallet = () => typeof window !== "undefined" && !!window.ethereum;

export function useConnectWallet() {
  const { connect, connectors, isPending } = useConnect();
  const [sheetOpen, setSheetOpen] = useState(false);
  const injectedConnector = connectors.find((c) => c.id === "injected") || connectors[0];
  const start = () => (hasInjectedWallet() ? connect({ connector: injectedConnector }) : setSheetOpen(true));
  const sheet = <WalletAppsSheet open={sheetOpen} onOpenChange={setSheetOpen} />;
  return { start, isPending, sheet };
}

export function ConnectWalletButton({ className, tid, children }) {
  const { start, isPending, sheet } = useConnectWallet();
  return (
    <>
      <button data-testid={tid} onClick={start} disabled={isPending} className={className}>
        {isPending ? "Connecting..." : children}
      </button>
      {sheet}
    </>
  );
}
